import router from '../../router'
import Notification_VariableService from '../../services/Notification_VariableService'

const state = () => ({
    loadingNotification_variables: false,
    notification_variable: null,
    notification_variables: [],
    total: 0,
    pages: 0,
    page: 1,
    show_modal_new_notification_variable: false,
    options: [
        { valeu: "fullName_User", description: "Nome Completo do usuário", exemple: "Guilherme Schiavon" },
        { valeu: "firstName_User", description: "Primeiro nome do usuário", exemple: "Guilherme" }
    ]
})
  
const mutations = {
    SET_NOTIFICATION_VARIABLE: (state, payload) => {
        state.notification_variable = payload
    },
    SET_NOTIFICATION_VARIABLES: (state, payload) => {
        state.notification_variables = payload; // Atualiza a lista inteira de variáveis
    },
    // SET_NOTIFICATION_VARIABLES: (state, payload) => {
    //     if(payload.pageNumber == 1) {
    //         state.notification_variables = payload.itens
    //     }else{
    //         state.notification_variables = [...state.notification_variables, ...payload.itens]
    //     }
    //     state.page =  payload.pageNumber
    //     state.pages =  payload.pages
    //     state.total =  payload.total
    // },
    SET_LOADING_NOTIFICATION_VARIABLES: (state, payload) => {
        state.loadingNotification_variable = payload
    },
    SET_SHOW_MODAL_NOTIFICATION_VARIABLE: (state, payload) => {
        state.show_modal_new_notification_variable = payload
    },
}

const actions = {
    async fetchNotification_variable({commit}, id){
        try{
            commit('SET_LOADING_NOTIFICATION_VARIABLES', true)
            const response = await Notification_VariableService.getOne(id);
            commit('SET_NOTIFICATION_VARIABLE', response.data)
            commit('SET_LOADING_NOTIFICATION_VARIABLES', false)
        } catch (error) {
            commit('SET_LOADING_NOTIFICATION_VARIABLES', false);
            if(error && error.response && error.response.data.message == "Sessão expirada") {
                commit('SET_REDIRECT', router.currentRoute.value.path);
            }
            commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async fetchNotification_variables({commit}, params = {}){
        try{
            commit('SET_LOADING_NOTIFICATION_VARIABLES', true)
            const { keyword = '', pageNumber = 1, pageSize = 12, order = { name: 'ID', column: 'ID', sort: 'ASC' } } = params;
            const response = await Notification_VariableService.get(keyword, pageNumber, pageSize, order);
            commit('SET_NOTIFICATION_VARIABLES', response.data)
            commit('SET_LOADING_NOTIFICATION_VARIABLES', false)
        } catch (error) {
            commit('SET_LOADING_NOTIFICATION_VARIABLES', false);
            if(error && error.response && error.response.data.message == "Sessão expirada") {
                commit('SET_REDIRECT', router.currentRoute.value.path);
            }
            commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async createNotification_variable({commit}, data){
        try{
            commit('SET_LOADING_NOTIFICATION_VARIABLES', true)
            const response = await Notification_VariableService.create(data);
            commit('SET_ALERT', {
                heading: 'success',
                message: response.data.message
            });
            commit('SET_SHOW_MODAL_NOTIFICATION_VARIABLE', false)
            commit('SET_LOADING_NOTIFICATION_VARIABLES', false)
        } catch (error) {
            commit('SET_LOADING_NOTIFICATION_VARIABLES', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async updadeNotification_variable({commit}, data){
        try{
            commit('SET_LOADING_NOTIFICATION_VARIABLES', true)
            const response = await Notification_VariableService.update(data);
            commit('SET_ALERT', {
                heading: 'success',
                message: response.data.message
            });
            commit('SET_LOADING_NOTIFICATION_VARIABLES', false)
        } catch (error) {
            commit('SET_LOADING_NOTIFICATION_VARIABLES', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
}

const getters = {
    getNotification_variable: state => state.notification_variable,
    getNotification_variables: state => state.notification_variables,
    getLoadingNotification_variable: state => state.loadingNotification_variable,
    getShowModalNewNotification_variable: state => state.show_modal_new_notification_variable,
    getNotification_variable_options: state => state.options
}

export default {
    state,
    getters,
    mutations,
    actions
};